import * as React from "react";
import { Table } from "react-bootstrap";
import { firestore } from "firebase";
import * as fs from "../firestore";
import moment from "moment";
import { soilTypeIndexLabelMap, deleteFlagLabelMap, dilutionRateLabelMap } from "../ResultsTableLabel";

export type AnalysisResult = fs.AnalysisResult & {id: string, userName: string};

interface Props {
    analysisResults: AnalysisResult[];
    showDeleteFlag: boolean;
    onImageLinkClicked: (analysisId: string, filename: string) => void;
}

export default class AnalysisResultsTable extends React.Component<Props, {}> {

    formatTimestamp(timestamp: firestore.Timestamp): string {
        return moment(timestamp.toDate()).format("YYYY年MM月DD日 HH:mm:ss");
    }

    render() {
        return (
            <div style={{margin: "30px 50px", overflowX: "auto"}}>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            {this.props.showDeleteFlag &&
                                <th>分析データID</th>
                            }
                            {this.props.showDeleteFlag &&
                                <th>ユーザID</th>
                            }
                            <th>利用者名</th>
                            {this.props.showDeleteFlag &&
                                <th>サンプルデータID</th>
                            }
                            <th>スコープID</th>
                            <th>分析項目ID</th>
                            <th>分析項目名</th>
                            <th>分析日時</th>
                            <th>希釈倍率</th>
                            <th>土質ID</th>
                            <th>吸光度1</th>
                            <th>吸光度2</th>
                            <th>吸光度3</th>
                            <th>吸光度4</th>
                            <th>吸光度5</th>
                            <th>吸光度平均値</th>
                            <th>濃度1(mg/L)</th>
                            <th>濃度2(mg/L)</th>
                            <th>濃度3(mg/L)</th>
                            <th>濃度4(mg/L)</th>
                            <th>濃度5(mg/L)</th>
                            <th>濃度平均値(mg/L)</th>
                            <th>濃度(mg/L)</th>
                            <th>Bray法結果(mg/100g)</th>
                            <th>Truog法結果(mg/100g)</th>
                            <th>硝酸態窒素濃度(mg/L)</th>
                            <th>土壌中の硝酸態窒素濃度(mg/100g)</th>
                            <th>コメント</th>
                            <th>作成日時</th>
                            <th>更新日時</th>
                            {this.props.showDeleteFlag &&
                                <th>削除フラグ</th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.analysisResults.map((result, index) => {
                            return (
                                <tr key={index}>
                                    {this.props.showDeleteFlag &&
                                        <td>{result.id}</td>
                                    }
                                    {this.props.showDeleteFlag &&
                                        <td>{result.userRef.id}</td>
                                    }
                                    <td>{result.userName}</td>
                                    {this.props.showDeleteFlag &&
                                        <td>{result.samplingResultRef.id}</td>
                                    }
                                    <td>{result.scopeId}</td>
                                    <td>{result.analysisId}</td>
                                    <td>{result.analysisName}</td>
                                    <td>{this.formatTimestamp(result.analysisDateTime)}</td>
                                    <td>{dilutionRateLabelMap[result.dilutionRate]}</td>
                                    <td>{soilTypeIndexLabelMap[result.soilTypeIndex]}</td>
                                    <td>{result.absorbance1}</td>
                                    <td>{result.absorbance2}</td>
                                    <td>{result.absorbance3}</td>
                                    <td>{result.absorbance4}</td>
                                    <td>{result.absorbance5}</td>
                                    <td>{result.absorbanceAvg}</td>
                                    <td>{result.concentration1}</td>
                                    <td>{result.concentration2}</td>
                                    <td>{result.concentration3}</td>
                                    <td>{result.concentration4}</td>
                                    <td>{result.concentration5}</td>
                                    <td>{result.concentrationAvg}</td>
                                    <td>{result.concentrationValue}</td>
                                    <td>{result.analysisId === 1 ? result.brayValue : "-"}</td>
                                    <td>{result.analysisId === 1 ? result.truogValue : "-"}</td>
                                    <td>{result.analysisId === 2 ? result.brayValue : "-"}</td>
                                    <td>{result.analysisId === 2 ? result.truogValue : "-"}</td>
                                    <td>{result.comment}</td>
                                    <td>{this.formatTimestamp(result.createDateTime)}</td>
                                    <td>{this.formatTimestamp(result.updateDateTime)}</td>
                                    {this.props.showDeleteFlag &&
                                        <td>{deleteFlagLabelMap[result.deleteFlag ? "true" : "false"]}</td>
                                    }
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            </div>
        );
    }
}
